import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';

const Wrapper = styled(NavLink)`
  color: #f2f2f2;
  font-weight: bold;
  height: 100%;
  min-height: 36px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 32px;
  box-sizing: border-box;
  font-size: 16px;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
  cursor: pointer;

  & > div {
    width: 100%;
    white-space: nowrap;
  }

  &.active {
    color: #f2f2f2;
    background-color: #7b95a6;
  }

  &:hover {
    background-color: #99b6ca;
  }

  &:link,
  &:visited {
    color: #f2f2f2;
  }

  @media screen and (max-width: 800px) {
    height: auto;
    justify-content: flex-start;
    font-size: 14px;
    width: 100px;
    padding: 0 16px;
  }
`;

const NavItem = ({ to, children }) => {
  return (
    <Wrapper exact to={to}>
      <div>{children}</div>
    </Wrapper>
  );
};

export default NavItem;
